import React from "react";

const LOPCard = ({ data, onEdit }) => {
  if (!data || data.length === 0) {
    return (
      <div className="w-full flex mx-10 gap-6">
        <div className="bg-white shadow-md border border-gray-100 rounded-lg max-w-[490px] p-6 mt-8 flex justify-center items-center">
          <p className="text-gray-400">No LOP settings found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-wrap gap-6 mx-10">
      {data.map((item, idx) => (
        <div
          key={item.id || idx}
          className="bg-white shadow-md border border-gray-100 rounded-lg max-w-[490px] p-6 mt-8"
        >
          <div className="flex items-center justify-between pb-4">
            <p className="text-base font-semibold text-[#1F2937]">
              Rules
            </p>
            <img
              src="/images/editicon.svg"
              alt="edit"
              className="cursor-pointer w-4 h-4"
              onClick={() => onEdit(item)}
            />
          </div>
          <div className="flex gap-6">
            <ul className="flex flex-col gap-3 text-sm font-normal text-gray-500">
              <li>Effective From</li>
              <li>Calculation Method</li>
              <li>Frequency</li>
              <li>Include Half Days</li>
              <li>Include Weekends</li>
              <li>Hide in Payslip</li>
              <li>Status</li>
            </ul>
            <ul className="flex flex-col gap-3 text-sm font-medium text-[#1F2937]">
              <li>{new Date(item.effective_from).toLocaleDateString()}</li>
              <li>{item?.calculation_method}</li>
              <li>{item?.frequecy_of_calucation}</li>
              <li>{item?.include_half_day ? "Yes" : "No"}</li>
              <li>{item?.include_weekends ? "Yes" : "No"}</li>
              <li>{item?.hide_in_payslip ? "Yes" : "No"}</li>
              <li>
                <span
                  className={`inline-block px-2 py-1 rounded text-white text-xs ${
                    item?.is_active ? "bg-green-500" : "bg-red-500"
                  }`}
                >
                  {item?.is_active ? "Active" : "Inactive"}
                </span>
              </li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LOPCard;
